/**
 * Created by lvardarova on 29/04/16.
 */
import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export function SocialPinterest(props) {
    return (
        <SvgIcon {...props}>
            <path d="M4.969,2c-2.761,0-5,2.239-5,5c0,2.047,1.231,3.806,2.993,4.58c-0.014-0.349-0.002-0.769,0.087-1.148 c0.096-0.406,0.643-2.724,0.643-2.724s-0.16-0.319-0.16-0.791c0-0.741,0.43-1.294,0.964-1.294c0.455,0,0.675,0.341,0.675,0.751 c0,0.457-0.292,1.141-0.442,1.774C4.604,8.677,4.996,9.11,5.519,9.11c0.947,0,1.586-1.217,1.586-2.659 c0-1.095-0.738-1.916-2.081-1.916c-1.518,0-2.462,1.131-2.462,2.395c0,0.436,0.129,0.743,0.329,0.981 C2.984,8.02,2.997,8.063,2.964,8.189C2.939,8.281,2.884,8.502,2.862,8.59c-0.034,0.126-0.136,0.172-0.25,0.125 c-0.699-0.285-1.024-1.05-1.024-1.91c0-1.42,1.198-3.123,3.574-3.123c1.909,0,3.165,1.381,3.165,2.864 c0,1.961-1.09,3.427-2.698,3.427c-0.54,0-1.048-0.292-1.222-0.623c0,0-0.29,1.152-0.352,1.374 c-0.106,0.385-0.314,0.771-0.503,1.071C4.001,11.928,4.477,12,4.969,12c2.761,0,5-2.239,5-5S7.73,2,4.969,2z" />
        </SvgIcon>
    );
}

SocialPinterest.defaultProps = {
    viewBox: '0 0 16 16'
};

export default SocialPinterest;
